module.exports = __webpack_public_path__ + "img/db_hero_img_mb.bbd19ffd.png";